export const WINNER_COLORS = [
  "#67B7D9",
  "#FF6868",
  "#FFA768",
  "#FFDE68",
  "#A1FF68",
  "#68FFE4",
  "#8F68FF",
  "#D868FF",
  "#FFCAF6",
  "#FFFFFF",
];

export const BREAKPOINT = 800;

export function findLastIndex<T>(
  array: T[],
  conditionFn = (item: T): boolean => {
    return true;
  },
) {
  const clonedArray = structuredClone(array);
  clonedArray.reverse();
  return array.length - 1 - clonedArray.findIndex(conditionFn);
}

export function getRandomColor() {
  let color = "";
  do {
    color = `#${Math.floor(Math.random() * 16777215).toString(
      16,
    )}`.toUpperCase();
  } while (WINNER_COLORS.includes(color));
  return color;
}
